import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { environment } from '@env/environment';
import { __ } from '@montblancsimpl/core';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(private toastr: ToastrService) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // skip error handler
    for (const regex of environment.skipHttpErrorInterceptor) {
      if (regex.test(request.url)) {
        return next.handle(request); // Found a match, no need to check further
      }
    }
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          !__.IsNullOrUndefinedOrEmpty(error) &&
          !__.IsNullOrUndefinedOrEmpty(error.error) &&
          !__.IsNullOrUndefinedOrEmpty(error.error.message) &&
          error.status === 400
        ) {
          this.toastr.error(error.error.description + ' ' + error.error.message);
        }
        return throwError(() => new HttpErrorResponse(error));
      }),
    );
  }
}
